<template>
  <div class="page">
    <van-nav-bar
      title="持仓明细"
      left-arrow
      @click-left="$router.push('capital_account?activeTab=2')"
    />
    <CommonLoading ref="commonLoader"></CommonLoading>

    <div class="content">

      <div class="depotCard" v-for="(item, index) in depotList" :key="index">
        <div class="cardTop">
          <div class="stockName">{{ item.name }}</div>
          <span class="stockCode">{{ item.short }}</span>
        </div>

        <div class="statGrid">
          <div class="statItem">
            <div class="statIconRow">
            
              <div class="statLabel">Available To Transfer</div>
            </div>
            <div class="statValue">{{ item.ai_surplus }}</div>
          </div>
          <div class="statItem">
            <div class="statIconRow">
              <div class="statLabel">AI Transferred</div>
            </div>
            <div class="statValue">{{ item.ai_number }}</div>
          </div>
        </div>

        <div class="cardActions">
          <button class="btnSecondary" @click="onMandate(item)">Mandate</button>
          <button class="btnPrimary" @click="onTransfer(item)">Transfer</button>
        </div>
      </div>

      <div v-if="depotList.length === 0" class="emptyState">
        暂无持仓
      </div>
    </div>

    <!-- Transfer Popup -->
    <van-popup
      v-model="showTransferPopup"
      round
      closeable
      close-icon-position="top-right"
      position="bottom"
      :style="{ maxHeight: '85%' }"
      class="transferPopup"
    >
      <div v-if="transferItem" class="popupContent">
        <div class="popupHeader">
          <div class="popupTitle">Transfer</div>
          <span class="stockCode">{{ transferItem.short }}</span>
        </div>

        <div class="statGrid">
          <div class="statItem">
            <div class="statLabel">Transferable Qty</div>
            <div class="statValue">{{ transferItem.ai_surplus }}</div>
          </div>
          <div class="statItem">
            <div class="statLabel">Transferable Capital</div>
            <div class="statValue">{{ transferable_capitalCashAmount }}</div>
          </div>
        </div>

        <div class="formGroup">
          <label class="formLabel">Transfer Qty</label>
          <input
            v-model="transferAmount"
            type="number"
            class="formInput"
            placeholder="请输入转让数量"
            @wheel.prevent
          />
          <div class="formError" v-if="transferError">{{ transferError }}</div>
        </div>

        <div class="formGroup">
          <label class="formLabel">Transfer Capital Amount</label>
          <input
            v-model="transferCapitalAmount"
            type="number"
            class="formInput"
            placeholder="请输入转让资本金额"
            @wheel.prevent
          />
          <div class="formError" v-if="transferCapitalError">{{ transferCapitalError }}</div>
        </div>

        <div class="formGroup">
          <label class="formLabel">Duration (days)</label>
          <input
            v-model="durationDays"
            type="number"
            class="formInput"
            placeholder="请输入天数"
            @wheel.prevent
          />
          <div class="formError" v-if="durationError">{{ durationError }}</div>
        </div>

        <button
          class="btnPrimary btnBlock"
          :disabled="transferSubmitting"
          @click="submitTransfer"
        >
          <span v-if="transferSubmitting">处理中...</span>
          <span v-else>确认转让</span>
        </button>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from "vue";
import { Dialog } from "vant";
Vue.use(Dialog);
import CommonLoading from "./CommonLoading";
export default {
  name: "AITradeDepot",
  components: {
    CommonLoading,
  },
  data() {
    return {
      depotList: [],

      // transfer popup state
      showTransferPopup: false,
      transferItem: null,
      transferAmount: "",
      transferError: "",
      durationDays: "",
      durationError: "",
      transferSubmitting: false,
      transferable_capitalCashAmount: 0,
      transferCapitalAmount: "",
      transferCapitalError: "",
    };
  },
  computed: {},
  methods: {
    getDepotStock() {
      let that = this;
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "depot_stock",
            token: sessionStorage.getItem("token"),
            cid: sessionStorage.getItem("cid"),
            direction: 0,
          },
        })
        .then(function (res) {
          that.depotList = [];
          if (res.data.code == 1) {
            that.depotList = res.data.data;
            console.log("dep", that.depotList);
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        })
        .finally(() => {
          that.$refs.commonLoader.hideCommonLoadigIcon();
        });
    },
    getCapitalRecord() {
      let that = this;
      that.$refs.commonLoader.showCommonLoadigIcon();
      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "capital_ai_info",
            token: sessionStorage.getItem("token"),
            cid: sessionStorage.getItem("cid"),
            direction: 0,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.transferable_capitalCashAmount = res.data.data;
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        })
        .finally(() => {
          that.$refs.commonLoader.hideCommonLoadigIcon();
        });
    },

    onTransfer(item) {
      this.transferItem = item;
      this.transferAmount = "";
      this.transferError = "";
      this.durationDays = "";
      this.durationError = "";
      this.transferCapitalAmount = "";
      this.transferCapitalError = "";
      this.showTransferPopup = true;
    },

    submitTransfer() {
      let that = this;
      const quantity = Number(that.transferAmount);
      const max = Number(that.transferItem.ai_surplus);
      const duration = Number(that.durationDays);
      const capitalAmount = Number(that.transferCapitalAmount);
      const maxCapital = Number(that.transferable_capitalCashAmount);

      if (!that.transferAmount || isNaN(quantity) || quantity <= 0) {
        that.transferError = "请输入有效的转让数量";
        return;
      }
      if (!Number.isInteger(quantity)) {
        that.transferError = "转让数量必须为整数";
        return;
      }
      that.transferError = "";
      if (quantity > max) {
        that.transferError = "转让数量不能超过可转让数量";
        return;
      }

      if (!that.transferCapitalAmount || isNaN(capitalAmount) || capitalAmount <= 0) {
        that.transferCapitalError = "请输入有效的转让资本金额";
        return;
      }
      if (!/^\d+(\.\d{1,2})?$/.test(that.transferCapitalAmount)) {
        that.transferCapitalError = "转让资本金额最多保留两位小数";
        return;
      }
      if (capitalAmount > maxCapital) {
        that.transferCapitalError = "转让资本金额必须小于可转让资本金额";
        return;
      }
      that.transferCapitalError = "";

      if (!that.durationDays || isNaN(duration) || duration <= 0 || !Number.isInteger(duration)) {
        that.durationError = "请输入有效的天数";
        return;
      }
      that.durationError = "";

      that.transferSubmitting = true;

      that
        .$http({
          url: "/",
          method: "post",
          data: {
            nozzle: "ai_transfer",
            token: sessionStorage.getItem("token"),
            cid: sessionStorage.getItem("cid"),
            short: that.transferItem.short,
            transfer_ai_quantity: quantity,
            transfer_ai_capital_amount: capitalAmount,
            duration_days: duration,
          },
        })
        .then(function (res) {
          if (res.data.code == 1) {
            that.$toast.success({
              message: res.data.msg || "转让成功",
              duration: 1000,
            });
            that.showTransferPopup = false;
            that.getDepotStock();
            that.getCapitalRecord();
          } else if (res.data.code == 0 || res.data.code == -1) {
            that.$toast.fail(res.data.msg);
          }
        })
        .finally(() => {
          that.transferSubmitting = false;
        });
    },

    // ---- Mandate: navigate to its own page ----
    onMandate(item) {
      this.$router.push({
        path: "/ai_trade_depot/mandate",
        query: {
          depot: item.ai_depot_id,
          code: item.short,
        },
      });
    },
  },
  mounted: function () {
    this.getDepotStock();
    this.getCapitalRecord();
  },
};
</script>

<style scoped>
.page {
  background: #f7f8fa;
  min-height: 100vh;
}

/* ---- AI Banner ---- */

.aiBanner {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 12px 12px 0;
  padding: 14px 16px;
  border-radius: 12px;
  background: linear-gradient(135deg, #652b29 0%, #D02E27 100%);
  box-shadow: 0 4px 12px rgba(106, 92, 255, 0.25);
}

.aiBannerIcon {
  width: 26px;
  height: 26px;
  color: #ffffff;
  flex-shrink: 0;
}

.aiBannerTitle {
  font-size: 15px;
  font-weight: 700;
  color: #ffffff;
}

.aiBannerSub {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.85);
  margin-top: 2px;
}

.content {
  padding: 12px 12px 30px;
}

.depotCard {
  background: #ffffff;
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 12px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0edff;
}

.cardTop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.stockName {
  font-size: 14px;
  font-weight: 700;
  color: #000;
}

.stockCode {
  font-size: 11px;
  font-weight: 500;
  color: #D02E27;
  background: #f2effe;
  padding: 2px 8px;
  border-radius: 4px;
}

.statGrid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 14px;
}

.statItem {
  background: linear-gradient(135deg, #f7f5ff 0%, #f2effe 100%);
  border-radius: 8px;
  padding: 8px 10px;
}

.statIconRow {
  display: flex;
  align-items: center;
  gap: 4px;
}

.statIcon {
  width: 11px;
  height: 11px;
  color: #D02E27;
  flex-shrink: 0;
}

.statLabel {
  font-size: 11px;
  color: #969799;
}

.statValue {
  font-size: 14px;
  font-weight: 600;
  color: #000;
  margin-top: 2px;
}

.cardActions {
  display: flex;
  justify-content: flex-end;
  gap: 6px;
}

.btnSecondary,
.btnPrimary {
  border: none;
  border-radius: 6px;
  padding: 5px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.btnSecondary:active,
.btnPrimary:active {
  opacity: 0.7;
}

.btnSecondary {
  background: #f2effe;
  color: #D02E27;
}

.btnPrimary {
  background: linear-gradient(135deg, #652b29 0%, #D02E27 100%);
  color: #ffffff;
}

.btnPrimary:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.btnBlock {
  width: 100%;
  padding: 10px 0;
  font-size: 14px;
  border-radius: 8px;
  margin-top: 6px;
}

.emptyState {
  text-align: center;
  padding: 40px 0;
  color: #969799;
  font-size: 14px;
}

/* ---- Transfer Popup ---- */

.transferPopup {
  background: #f7f8fa;
}

.popupContent {
  padding: 18px 16px 24px;
}

.popupHeader {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.popupHeaderIcon {
  width: 18px;
  height: 18px;
  color: #D02E27;
}

.popupTitle {
  font-size: 16px;
  font-weight: 700;
  color: #000;
}

.formGroup {
  background: #ffffff;
  border-radius: 10px;
  padding: 10px 14px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0edff;
}

.formLabel {
  display: block;
  font-size: 11px;
  color: #969799;
  margin-bottom: 4px;
}

.formInput {
  width: 100%;
  border: none;
  outline: none;
  font-size: 14px;
  color: #000;
  background: transparent;
  padding: 0;
  -moz-appearance: textfield;
}

.formInput::-webkit-outer-spin-button,
.formInput::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.formInput::placeholder {
  color: #c8c9cc;
}

.formError {
  font-size: 11px;
  color: #ee0a24;
  margin-top: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/AITradeDepot.vue